const getters = {
  msgNum: state => state.app.msgNum,
  socketFlag: state => state.app.socketFlag
}
export default getters
